import { MigrationSpec } from "../migration.models"

const metaAdsReportMetricTemplates: MigrationSpec = {
  type: "SEED_META_ADS_REPORT_METRIC_TEMPLATES",
  collection: "ReportWidgetMetricTemplates",
  risk: "SAFE",
  title: {
    en: "Meta Ads → report metric templates",
    tr: "Meta Ads → rapor metrik şablonları"
  },
  description: {
    en:
      "Inserts the four `meta_ads` report metric templates when missing: conversations " +
      "(`meta_ads_conversations`), clicks (`meta_ads_clicks`), conversions " +
      "(`meta_ads_conversions`) and conversion value (`meta_ads_conversion_value`). Written with " +
      "`$setOnInsert`, so a second run changes nothing and existing (possibly edited) templates " +
      "are never overwritten.",
    tr:
      "Eksikse dört `meta_ads` rapor metrik şablonunu ekler: konuşmalar " +
      "(`meta_ads_conversations`), tıklamalar (`meta_ads_clicks`), dönüşümler " +
      "(`meta_ads_conversions`) ve dönüşüm değeri (`meta_ads_conversion_value`). `$setOnInsert` " +
      "ile yazılır: ikinci çalıştırma hiçbir şey değiştirmez, mevcut (düzenlenmiş olabilecek) " +
      "şablonların üzerine asla yazılmaz."
  },
  expectedDocuments: {
    filter: {
      dataSource: "meta_ads",
      metricType: {
        $in: [
          "meta_ads_conversations",
          "meta_ads_clicks",
          "meta_ads_conversions",
          "meta_ads_conversion_value"
        ]
      }
    },
    count: 4
  },
  notes: [
    {
      en:
        "Run before “Meta Ads → report widget templates”: those widgets reference these metric " +
        "templates.",
      tr:
        "“Meta Ads → rapor widget şablonları”ndan önce çalıştırın: o widget'lar bu metrik " +
        "şablonlarına referans verir."
    }
  ]
}

export default metaAdsReportMetricTemplates
